import {
  GetMissingFieldsLevelParameter,
  OnboardingMissingFields,
  VerificationLevel
} from "@wingspanhq/wingspan-api-sdk";
import { onboardingApi } from "@api";
import { queriesOnboarding } from "@query";
import { verificationService } from "../../../shared/services/verificaiton";

export type VerificationState = {
  status: VerificationLevel;
  usPersonStatus: VerificationLevel;
  missingData: OnboardingMissingFields;
};

export async function getVerificationState(
  verificationLevel: GetMissingFieldsLevelParameter
): Promise<VerificationState> {
  const [status, missingData] = await Promise.all([
    onboardingApi.getOnboardingStatus({}),
    onboardingApi.getMissingFields({ level: verificationLevel })
  ]);

  queriesOnboarding.getMissingFields.setQueryData(
    { level: verificationLevel },
    missingData
  );
  queriesOnboarding.getOnboardingStatus.setQueryData(undefined, status);

  const verifications = status.verifications ?? {};

  const verificationStatus = verificationService.getVerificationStatus(
    verificationLevel,
    verifications
  );

  const usPersonStatus = verificationService.getUSPersonVerificationStatus(
    GetMissingFieldsLevelParameter.TAX,
    verifications
  );

  return {
    status: verificationStatus,
    usPersonStatus,
    missingData
  };
}
